import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

export const DeviceIcon = ({
  platform,
  className,
}: {
  platform: string;
  className?: string;
}) => {
  const Icon = platform === 'windows' ? Icons.monitor : Icons.laptop;
  return <Icon className={cn('shrink-0', className)} />;
};
